import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
    fetchNotifications,
    fetchNotificationById,
    markNotificationAsRead,
    bulkMarkNotificationsAsRead,
    deleteNotification,
} from './notification-api';

/* ---------------------- LIST (لیست نوتیف‌ها) ---------------------- */
export const useNotifications = (page = 0, pageSize = 10, filters = {}) =>
    useQuery({
        queryKey: ['notifications', page, pageSize, filters],
        queryFn: () => fetchNotifications(page, pageSize, filters),
        keepPreviousData: true,
    });

/* ---------------------- SINGLE (یک نوتیف) ---------------------- */
export const useNotification = (id) =>
    useQuery({
        queryKey: ['notification', id],
        queryFn: () => fetchNotificationById(id),
        enabled: !!id,
    });

/* ---------------------- MARK AS READ (تکی) ---------------------- */
export const useMarkNotificationAsRead = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: markNotificationAsRead, // expects (id)
        onSuccess: (data, id) => {
            queryClient.invalidateQueries({queryKey: ['notifications']});

            if (id) {
                queryClient.invalidateQueries({queryKey: ['notification', id]});
            }
            onSuccess?.(data, id);
        },
    });
};

/* ---------------------- BULK MARK AS READ (همه) ---------------------- */
export const useBulkMarkNotificationsAsRead = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: bulkMarkNotificationsAsRead,
        onSuccess: (data) => {
            queryClient.invalidateQueries({queryKey: ['notifications']});
            onSuccess?.(data);
        },
    });
};

/* ---------------------- DELETE ---------------------- */
export const useDeleteNotification = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteNotification, // expects (id)
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({queryKey: ['notifications']});
            if (id) {
                queryClient.removeQueries({queryKey: ['notification', id]});
            }
            onSuccess?.();
        },
    });
};
